<div class="list-preview" *ngIf="withPreview" (click)="setEditMode(true)">
	<bb-list [options]="modelValue" [limit]="3"></bb-list>
</div>

<!-- withPreview will display and show editor in pane -->
<div class="edit-mode-wrapper" [hidden]="withPreview && !editMode" [class.in-modal]="withPreview"
	(click)="setEditMode(false)">
	<div *ngIf="withPreview" class="inner" (click)="$event.stopPropagation()">
		<bb-modal [title]="'SELECT_OPTIONS' | translate" [showCloseButton]="true" class="{{theme}}-theme">
			<ng-container *ngTemplateOutlet="optionTemplate"></ng-container>
			<div class="button-bar">
				<div class="bar-button" (click)="setEditMode(false)">
					{{ 'CLOSE' | translate }}
				</div>
			</div>
		</bb-modal>
	</div>
	<div *ngIf="!withPreview">
		<ng-container *ngTemplateOutlet="optionTemplate"></ng-container>
	</div>
</div>

<ng-template #optionTemplate>
	<div class="grid" [style.grid-template-columns]="'repeat(' +  (2 + (showActiveCheckbox ? 1 : 0)) + ', minmax(0, auto)) ' + (extraColumns?.length ? ('repeat(' + extraColumns.length + ', 70px)') : '') + ' 43px'">
		<!-- Header row -->
		<ng-container *ngIf="modelValue?.length">
			<!--  class="field-options-header"  -->
			<div *ngIf="showActiveCheckbox">
				<strong>{{ 'ACTIVE' | translate }}</strong>
			</div>
			<div class="list-header">
				<strong>{{ 'LABEL' | translate }}</strong>
			</div>
			<div class="list-header code-cv">
				<strong>{{ (codeProp === 'code' ? 'CODE' : 'VALUE') | translate }}</strong>
				<span class="with-check">
					<span class="custom-values-label">
						{{ (codeProp === 'code' ? 'CUSTOM_CODES' : 'CUSTOM_VALUES') | translate }}
					</span>
					<bb-check [(ngModel)]="useCustomValues" name="useCustomValues"
						[theme]="theme === 'dark' ? theme + '-theme' : ''" class="small"></bb-check>
				</span>
			</div>
			<div *ngFor="let extraHeader of extraColumns">
				<strong>{{ extraHeader.header }}</strong>
			</div>
			<div>
				<!-- placeholder delete icon -->
			</div>
		</ng-container>

		<!-- Row per item -->
		<ng-container *ngIf="modelValue?.length">
			<!--  class="list-items" -->
			<!--  class="list-item" -->
			<ng-container *ngFor="let option of modelValue; let i = index">
				<ng-container *ngIf="!option.hidden">
					<!--  class="list-row" -->
					<div *ngIf="showActiveCheckbox">
						<bb-check [(ngModel)]="option.active" (ngModelChange)="modelChange()" name="optionChecked"
							[theme]="theme === 'dark' ? theme + '-theme' : ''" class="small"></bb-check>
					</div>
					<input type="text" [(ngModel)]="option.label" class="field-option label-field" autofocus
						[disabled]="option.disabled" [ngModelOptions]="{standalone: true}"
						(ngModelChange)="optionValueChange(i)" (keyup.enter)="onLabelFieldEnter()" />
					<input type="text" [disabled]="!useCustomValues || option.disabled" [(ngModel)]="option[codeProp]"
						(ngModelChange)="optionCodeChange(i)" class="field-option"
						[ngModelOptions]="{standalone: true}" />
					<div *ngFor="let extraProp of extraColumns">
						<input *ngIf="!extraProp.type || extraProp.type === 'number'" type="number"
							[(ngModel)]="option[extraProp.field]" (ngModelChange)="modelChange()" class="field-option"
							[ngModelOptions]="{standalone: true}" [disabled]="option.disabled"
							[required]="extraProp.required" />
					</div>
					<div class="remove">
						<bb-button icon="trash" (click)="removeOption(i)" title="Remove option" [theme]="theme"
							[disabled]="option.disabled"></bb-button>
					</div>
				</ng-container>
			</ng-container>
		</ng-container>
	</div>

	<div class="list-item" *ngIf="!modelValue || modelValue?.length === 0">
		<span class="message warning">{{ 'NO_OPTIONS_SET' | translate }}</span>
	</div>
	<bb-button icon="plus" (click)="addOption()" [theme]="theme">
		{{ 'ADD_OPTION' | translate }}
	</bb-button>
</ng-template>
